import React, { FC } from 'react';
import { Popup } from '@components/atoms/Popup';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import styles from './PopupFullWidthOnMobile.module.css';

export interface PopupFullWidthOnMobileProps {
    id?: string;
    show: boolean;
    onHide: () => void;
    title: string;
    children: JSX.Element | JSX.Element[];
}

export const PopupFullWidthOnMobile: FC<PopupFullWidthOnMobileProps> = ({ id, show, onHide, title, children }) => {
    return (
        <Popup
            id={id || undefined}
            show={show}
            onHide={onHide}
            header={
                <>
                    <div className={styles.header}>
                        <Typography tagVariant={TypographyTagVariants.h5} fontWeight="900" fontSize="20">
                            {title}
                        </Typography>
                    </div>
                    <hr className={styles.divider} />
                </>
            }
            desktopWidth="444px"
            fullWidthOnMobile={true}>
            <div className={styles.content}>{children}</div>
        </Popup>
    );
};
